import { render } from "./app-footer-engineer.vue?vue&type=template&id=188e360a&scoped=true&ts=true"
import script from "./app-footer-engineer.vue?vue&type=script&lang=ts"
export * from "./app-footer-engineer.vue?vue&type=script&lang=ts"

import "./app-footer-engineer.vue?vue&type=style&index=0&id=188e360a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188e360a"]])

export default __exports__